<template>
    <div class="scope-dropdown-panel">
        <slot name="header" />

        <div
            v-on-click-outside.bubble="setOutsideHandler"
            class="scope-dropdown-panel__dropdown_manager"
            :style="{
                [orientation]: orientationPos,
                width: width
            }"
            :class="{
                'scope-dropdown-panel__dropdown_manager--active': isOpen
            }"
        >
            <div
                class="scope-dropdown-panel__dropdown-header"
                v-if="haveHeader"
            >
                <span>{{ title }}</span>
                <Icon
                    v-if="isClosePopup"
                    icon="close-popup"
                    @click="$emit('closePopup')"
                />
            </div>
            <slot name="searchInput" />
            <slot name="body" />
            <slot name="footer" />
        </div>
    </div>
</template>

<script setup>
import { vOnClickOutside } from '@vueuse/components';
import { onMounted, onUnmounted } from 'vue';

import Icon from './Icon.vue';

const props = defineProps({
    title: { type: String },
    isClosePopup: { type: Boolean, default: true },
    haveHeader: { type: Boolean, default: true },
    isOpen: { type: Boolean },
    orientation: { type: String, default: 'right' },
    orientationPos: { type: String, default: '0' },
    width: { type: String, default: '230px' }
});

const emit = defineEmits(['outsideClick', 'closePopup']);

const setOutsideHandler = (event) => {
    emit('outsideClick');
};

const closeOnScroll = () => {
    if (!props.isOpen) return;
    emit('closePopup');
};

onMounted(() => {
    window.addEventListener('scroll', closeOnScroll, true);
});

onUnmounted(() => {
    window.removeEventListener('scroll', closeOnScroll, true);
});
</script>

<style scoped lang="scss">
@import '@/assets/styles/main';

.scope-dropdown-panel {
    position: relative;

    &__dropdown {
        &_manager {
            position: absolute;
            top: 110%;
            opacity: 0;
            visibility: hidden;
            @include transition-default;
            padding: 8px;
            gap: 10px;
            border-radius: 12px;
            background: $card-background;
            border: 1px solid $border;
            @include shadow-small;
            z-index: 104;

            &--active {
                opacity: 1;
                visibility: visible;
            }
        }

        &-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 14px;

            svg {
                cursor: pointer;
            }

            span {
                color: $text-high-emphasis;
                @include fz-14;
                font-weight: 500;
            }
        }
    }
}

body[theme='dark'] .scope-dropdown-panel {
    .scope-dropdown-panel__dropdown_manager {
        background: $card-neutral-background;
        border-color: $border-secondary;
    }
}
</style>
